<template>
  <div id="fullContents">
        <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
        <div id="suningAgree">
            <div>
            <p style="font-size:14pt; line-height:115%; margin:0pt 0pt 10pt; orphans:0; text-align:center; widows:0">
                <a name="_Toc368307800">
                    <span style="font-family:彩虹小标宋; font-size:14pt">个人征信授权书</span>
                </a>
            </p>
            <p style="line-height:17pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">尊敬的客户：为了维护您的权益，请在签署本授权书前，仔细阅读本授权书各条款，关注您在授权书中的权利、义务。</span>
            </p>
            <p style="line-height:17pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:12pt">江苏苏宁银行股份有限公司：</span>
            </p>
            <p style="line-height:17pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:12pt">一、本人同意并不可撤销地授权：</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt">贵行按照国家相关规定采集并向</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">金融信用信息基础数据库及其他依法成立的征信机构提供本人个人信息和包括信贷信息在内的</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">信用信息</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-style:italic; font-weight:bold">（包含但不限于本人因未及时履行合同义务产生的不良信息）</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">。</span>
            </p>
            <p style="line-height:17pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:12pt">二、本人同意并不可撤销地授权：</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt">贵行可以根据国家有关规定，在办理涉及本人的业务时，</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">有权向</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">金融信用信息基础数据库</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">及其他依法成立的征信机构</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">查询、打印、保存本人的信用信息</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt">，并用于下述用途：</span>
            </p>
            <p style="line-height:17pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:12pt">（一）审核本人贷款申请；</span>
            </p>
            <p style="line-height:17pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:12pt">（二）审核本人作为提出贷款申请的个人、组织或机构的负责人、法定代表人、出资人、担保人、企业经营者、实际控制人；</span>
            </p>
            <p style="line-height:17pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:12pt">（三）对已向本人或本人担任法人、出资人、担保人、企业经营者、实际控制人的个人、机构或组织发放的贷款进行贷后风险管理；</span>
            </p>
            <p style="line-height:17pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:12pt">（四）向本人提供其他贵行合法经营范围内的业务。</span>
            </p>
            <p style="line-height:17pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:normal">三、</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">本授权书自本人</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">在</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">相关页面</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">点击或勾选“确认授权”并</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">进行电子签名确认后生效，本授权书有效期至本人业务结清</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">/办结</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">之日止</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">，</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">包含授信额度有效期以及授信额度有效期内支用的每笔借款结清前的任意时点，其中，循环额度不以本人是否有借据余额作为前提条件；或者本人在被授权人处办理的业务被转让、被授权人作为管理服务人时，被授权人仍有权查询、报送本人的后续信息</span>
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">。</span>
            </p>
            <p style="line-height:17pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">四、若本人在贵行业务未获批准办理，本授权书及本人信用报告等资料无须退回本人。</span>
            </p>
            <p style="line-height:17pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:12pt; font-weight:bold">本人声明：本人已仔细阅读上述所有条款。贵行已应本人要求对相关条款予以明确说明。本人对所有条款的含义及相应的法律后果已全部通晓并充分理解，本人自愿作出上述授权、承诺和声明。</span>
            </p>
            <p style="line-height:17pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:12pt">&#xa0;</span>
            </p>
            <p style="line-height:17pt; margin:0pt 0pt 10pt; orphans:0; text-align:right; text-indent:21pt; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:12pt">&#xa0;</span>
            </p>
            <p style="line-height:17pt; margin:0pt 48pt 10pt 0pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:12pt">本人姓名：</span>
            </p>
            <p style="line-height:17pt; margin:0pt 48pt 10pt 0pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:12pt">证件名称及号码：身份证，</span>
            </p>
            <p style="line-height:17pt; margin:0pt 48pt 10pt 0pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:12pt">签署日期：  年   月   日</span>
            </p>
            <p style="line-height:26pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt">&#xa0;</span>
            </p>
            <p style="font-size:10.5pt; line-height:115%; margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt">&#xa0;</span>
            </p>
        </div>
        </div>
  </div>
</template>
<script>
export default {
  components: {  },
  name: 'suningPersonalCreditAuthorize',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  mounted() {
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
/* common css */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: '微软雅黑';
}
p {
  /* margin-bottom: 8px; */
}
#fullContents {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
#fullContents .crossBox{
  text-align: right;
}
#fullContents .cross{
  font-size: 20px;
}
#suningAgree {
  overflow: scroll;
  line-height: 20px;
  text-align: left;
  -webkit-overflow-scrolling: touch;
}
#suningAgree .title {
    font-size: 15px;
    text-align: center;
}
#suningAgree .bold {
    font-weight: bold;
}
#suningAgree .center {
    text-align: center;
}
#suningAgree .right {
    text-align: right;
}
#suningAgree .underline {
    text-decoration: underline;
}
#suningAgree .write-line {
    overflow: hidden; 
    width: 90%; ;
    margin: 0 auto;
}
</style>
